import styled from "styled-components";
import Col from "../../UIcomponent/Column";

export const Layout = styled(Col)`
  display: ${(props) => props.visible === false && "none"};
  flex-direction: column;
  justify-content: flex-start;
  width: 100vw;
  height: 330px;
  background-color: white;
  box-shadow: ${(props) => props.theme.shadow};
  bottom: 0px !important;
  /* left: 0px !important; */
  @media screen and (max-width: 768px) {
    height: 402px;
    justify-content: center;
  }
`;
export const TopLineContainer = styled(Col)`
  min-height: 10px;
  height: 10px;
  width: 100%;
  flex-direction: row-reverse;
  border-bottom: 1px solid #f4f4f4;
`;
export const TopLine = styled(Col)`
  min-height: 100%;
  height: 100%;
  background-color: ${(props) => props.color};
`;
export const PlatformInformation = styled(Col)`
  height: 100px;
  justify-content: flex-start;
  .footerLogoType {
    width: auto;
    font-size: 2.5em;
  }
  .footerLogoType--res {
    display: none;
  }
  @media screen and (max-width: 768px) {
    height: 80px;
    .footerLogoType {
      display: none;
    }
    .footerLogoType--res {
      display: flex;
      width: auto;
      font-size: 0.8em;
    }
  }
`;
export const MiddleContainer = styled(Col)`
  height: 160px;
  flex-wrap: wrap;
  @media screen and (max-width: 996px) {
    height: auto;
  }
  @media screen and (max-width: 768px) {
    height: 260px;
  }
`;
export const MiddleCell = styled(Col)`
  height: 100%;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: ${(props) => props.secondary && "flex-end"};
  @media screen and (max-width: 996px) {
    height: 180px;
  }
  @media screen and (max-width: 768px) {
    height: 130px;
    flex-direction: ${(props) => props.reverse && "row-reverse"};
  }
`;

export const LinkContainer = styled(Col)`
  height: 100%;
  justify-content: flex-start;
  flex-direction: column;
  z-index: 80;
  a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 30px;
    font-size: 14px;
    cursor: pointer;
    font-family: "Fa_IRANSansMedium";
    color: ${(props) => props.theme.textLight};
    text-decoration: none;

    @media screen and (max-width: 768px) {
      font-size: 12px;
    }
  }
`;
export const ContactUs = styled(Col)`
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  div {
    width: 90%;
    justify-content: flex-start;
    height: 30px;
    a {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 90%;
      height: 30px;
      color: #333333;
      font-size: 18px;
      text-decoration: none;
      @media screen and (max-width: 768px) {
        font-size: 12px;
        div:nth-of-type(1) {
          font-size: 12px;
        }
      }
    }
  }
`;
export const Enamad = styled(Col)`
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    border-radius: none;
    box-shadow: none;
    img {
      width: 80%;
      height: 80%;
      @media screen and (max-width: 768px) {
        width: 100%;
        height: 100%;
      }
    }
    @media screen and (max-width: 768px) {
      width: 90px;
      height: 90px;
    }
  }
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
  }
`;
export const SocialMediaWrapper = styled(Col)`
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
`;
export const SocialMediaTitle = styled(Col)`
  height: 40px;
  width: 100%;
  font-size: 14px;
  color: #333333;
  justify-content: flex-end;
  font-family: "Fa_IRANSansMedium";
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
  }
`;
export const SocialMediaContainer = styled(Col)`
  height: 60px;
  justify-content: flex-end;
  @media screen and (max-width: 768px) {
    justify-content: flex-end;
    flex-direction: row-reverse;
  }
`;
export const SocialMedia = styled(Col)`
  height: 100%;
  width: 40px;
  flex-direction: row-reverse;
  justify-content: flex-start;
  a {
    width: 26px;
    height: 26px;
    justify-content: flex-end;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: left;
    @media screen and (max-width: 768px) {
      width: 22px;
      height: 22px;
    }
  }
  @media screen and (max-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`;
export const BottomContainer = styled(Col)`
  height: 130px;
  border-top: 1px solid #f4f4f4;
  @media screen and (max-width: 768px) {
    height: 60px;
  }
`;
export const RightReserve = styled(Col)`
  height: 50px;
  justify-content: flex-start;
  direction: ltr;
  font-size: ${(props) => props.theme.fontSizeMd};
  color: ${(props) => props.theme.textLight};
  font-family: "IRANSansWeb";
  @media screen and (max-width: 768px) {
    font-size: ${(props) => props.theme.fontSizeSm};
  }
`;
